<div class="ap-modal-header col-11">
  <div class="ap-modal-title">
    <div #headerContainer>
      <ng-content></ng-content>
    </div>
    @if (hasNotChildren) {
      <h2>{{ title }}</h2>
    }
  </div>
</div>
<div class="ap-modal-header-icons-container">
  @if (hasCloseButton) {
    <button
      type="button"
      class="ap-modal-header-icon ap-modal-header-close"
      (click)="cancelHandler()">
      <span class="Appkit4-icon icon-close-outline"></span>
    </button>
  }
</div>
